import { Component, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'ccl-alert',
  standalone: true,
  imports: [],
  templateUrl: './alert.html',
  styleUrls: ['./alert.css'],
})
export class AlertComponent {
  @Input() variant: 'info' | 'success' | 'warning' | 'error' = 'info';
  @Input() message = '';
  @Input() title?: string;
  @Input() dismissible = false;
  @Input() showIcon = true;
  @Input() icon?: string;

  @Output() closed = new EventEmitter<void>();

  close() {
    this.closed.emit();
  }

  getDefaultIcon(): string {
    switch (this.variant) {
      case 'success': return '✓';
      case 'warning': return '⚠';
      case 'error': return '✕';
      case 'info':
      default: return 'ℹ';
    }
  }
}
